import { render, staticRenderFns } from "./EmployeesInvestmentImport.vue?vue&type=template&id=04ec3b10"
import script from "./EmployeesInvestmentImport.vue?vue&type=script&lang=js"
export * from "./EmployeesInvestmentImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports